/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelsFrequencyRange } from './ModelsFrequencyRange';
import {
    ModelsFrequencyRangeFromJSON,
    ModelsFrequencyRangeFromJSONTyped,
    ModelsFrequencyRangeToJSON,
} from './ModelsFrequencyRange';

/**
 * 
 * @export
 * @interface OutputUserProfile
 */
export interface OutputUserProfile {
    /**
     * 
     * @type {boolean}
     * @memberof OutputUserProfile
     */
    darkTheme: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUserProfile
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUserProfile
     */
    ewLastDirectionName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUserProfile
     */
    ewLastDurationMinutes?: number;
    /**
     * 
     * @type {Array<ModelsFrequencyRange>}
     * @memberof OutputUserProfile
     */
    ewLastSelectedRanges?: Array<ModelsFrequencyRange>;
    /**
     * 
     * @type {number}
     * @memberof OutputUserProfile
     */
    ewLastZoneId?: number;
    /**
     * 
     * @type {Array<ModelsFrequencyRange>}
     * @memberof OutputUserProfile
     */
    ewSavedFrequencyRanges?: Array<ModelsFrequencyRange>;
    /**
     * 
     * @type {number}
     * @memberof OutputUserProfile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUserProfile
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUserProfile
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputUserProfile
     */
    showPreferredChannelsOnly: boolean;
}

/**
 * Check if a given object implements the OutputUserProfile interface.
 */
export function instanceOfOutputUserProfile(value: object): boolean {
    if (!('darkTheme' in value)) return false;
    if (!('email' in value)) return false;
    if (!('id' in value)) return false;
    if (!('locale' in value)) return false;
    if (!('name' in value)) return false;
    if (!('showPreferredChannelsOnly' in value)) return false;
    return true;
}

export function OutputUserProfileFromJSON(json: any): OutputUserProfile {
    return OutputUserProfileFromJSONTyped(json, false);
}

export function OutputUserProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUserProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'darkTheme': json['darkTheme'],
        'email': json['email'],
        'ewLastDirectionName': json['ewLastDirectionName'] == null ? undefined : json['ewLastDirectionName'],
        'ewLastDurationMinutes': json['ewLastDurationMinutes'] == null ? undefined : json['ewLastDurationMinutes'],
        'ewLastSelectedRanges': json['ewLastSelectedRanges'] == null ? undefined : ((json['ewLastSelectedRanges'] as Array<any>).map(ModelsFrequencyRangeFromJSON)),
        'ewLastZoneId': json['ewLastZoneId'] == null ? undefined : json['ewLastZoneId'],
        'ewSavedFrequencyRanges': json['ewSavedFrequencyRanges'] == null ? undefined : ((json['ewSavedFrequencyRanges'] as Array<any>).map(ModelsFrequencyRangeFromJSON)),
        'id': json['id'],
        'locale': json['locale'],
        'name': json['name'],
        'showPreferredChannelsOnly': json['showPreferredChannelsOnly'],
    };
}

export function OutputUserProfileToJSON(value?: OutputUserProfile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'darkTheme': value['darkTheme'],
        'email': value['email'],
        'ewLastDirectionName': value['ewLastDirectionName'],
        'ewLastDurationMinutes': value['ewLastDurationMinutes'],
        'ewLastSelectedRanges': value['ewLastSelectedRanges'] == null ? undefined : ((value['ewLastSelectedRanges'] as Array<any>).map(ModelsFrequencyRangeToJSON)),
        'ewLastZoneId': value['ewLastZoneId'],
        'ewSavedFrequencyRanges': value['ewSavedFrequencyRanges'] == null ? undefined : ((value['ewSavedFrequencyRanges'] as Array<any>).map(ModelsFrequencyRangeToJSON)),
        'id': value['id'],
        'locale': value['locale'],
        'name': value['name'],
        'showPreferredChannelsOnly': value['showPreferredChannelsOnly'],
    };
}

